import Navbar from "./Components/Navbar";
import { init } from "ityped";
import { useEffect } from "react";
import WorkExperience from "./Partials/WorkExperience";
import Contact from "./Partials/Contact";
import Header from "./Partials/Header";
import About from "./Partials/About";
import Projects from "./Partials/Projects";

function App() {
  useEffect(() => {
    const textElement = document.querySelector("#textElement");
    init(textElement, {
      showCursor: true,
      strings: [
        "Freelancer",
        "Web Developer",
        "Mobile App Developer",
        "BI & Data Analyst",
      ],
    });
  }, []);

  return (
    <div>
      <Navbar />

      <div className="h-[calc(100vh-70px)] bg-red-200">
        <Header />

        <About />

        <Projects />

        <WorkExperience />

        <Contact />

      </div>
    </div>
  );
}

export default App;
